import React, { Component } from "react";
import EventoCard from "./EventoCard.jsx";

class Eventos extends Component {
  componentDidMount() {
    window.startx();
  }

  render() {
    const eventos = [

      {
        img: "images/Blog/consejoenero.jpg",
        titulo: "Taller Viernes de Consejo Enero 2026",
        fecha: "9 de febrero de 2026",
        descripcion: "Durante el Taller de Viernes de Consejo del mes de enero, las niñas y los niños vivie ...",
        link: "/consejoenero",
      },
      {
        img: "images/Blog/dinoiluminadoportada.jpg",
        titulo: "Dinoparque Iluminado",
        fecha: "19 de enero de 2026",
        descripcion: "Muchas gracias a todos los que nos acompañaron en el Dinoparque Iluminado ...",
        link: "/dinoparqueiluminado",
      },
      {
        img: "images/Blog/salarvportada.jpg",
        titulo: "Nueva Sala de Realidad Virtual",
        fecha: "15 de enero de 2026",
        descripcion: "Ven y conoce nuestra nueva Sala de Realidad Virtual...",
        link: "/nuevasalarv",
      },
      {
        img: "images/Blog/dinosanimatronicosportada.jpg",
        titulo: "¡Llegaron nuevos dinosaurios animatrónicos al Dinoparque!",
        fecha: "15 de enero de 2026",
        descripcion: "Ven a conocer los nuevos dinosaurios mecatrónicos del Dinoparque...",
        link: "/dinosanimatronicos",
      },
      {
        img: "images/Blog/portada7.jpg",
        titulo: "Noches de Terror en Dinoparque",
        fecha: "22 de octubre de 2025",
        descripcion: "Las Noches de Terror en Dinoparque fueron todo un éxito...",
        link: "/nochesdeterror",
      },
      {
        img: "images/Blog/portada5.jpg",
        titulo: "Concurso de Creatividad e Ingenio 2025",
        fecha: "22 de octubre de 2025",
        descripcion: "Vive la creatividad y la imaginación en uno de los concursos más importantes del museo...",
        link: "/cci2025",
      },
      {
        img: "images/Blog/portada6.jpg",
        titulo: "Noches de Terror en Dinoparque",
        fecha: "20 de octubre de 2025",
        descripcion: "Este 31 de octubre y 1 de noviembre, el Dinoparque se transforma en un escenario lleno de misterio...",
        link: "/nochesterror",
      },
      {
        img: "images/Blog/portada4.jpg",
        titulo: "Día por la Integridad",
        fecha: "19 de septiembre de 2025",
        descripcion: "La ética como base del servicio público. En el marco del Día de la Integridad reflexionamos...",
        link: "/diaintegridad",
      },
      {
        img: "images/Blog/portada2.jpg",
        titulo: "Festival por el Bienestar Socioemocional",
        fecha: "1 de octubre de 2025",
        descripcion: "El Museo Interactivo El Rehilete fue sede del Festival Escolar por el Bienestar Socioemocional...",
        link: "/festivalse",
      },
      {
        img: "images/Blog/portada3.jpg",
        titulo: "Día Internacional de la Científica",
        fecha: "28 de septiembre de 2025",
        descripcion: "Celebramos el Día Internacional de la Cultura Científica con actividades interactivas...",
        link: "/diaintercc",
      },
      {
        img: "images/Blog/simulacro2025.jpg",
        titulo: "Simulacro Nacional 2025",
        fecha: "19 de septiembre de 2025",
        descripcion: "El Museo Interactivo El Rehilete se sumó activamente al Simulacro Nacional...",
        link: "/simulacro2025",
      },
      
    ];

    return (
      <div className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Blog</h2>
            <h4>En esta sección encontrarás noticias y eventos del Museo El Rehilete</h4>
          </header>

          <div className="row">
            {eventos.map((ev, idx) => (
              <div className="col-md-4 mb-4" key={idx}>
                <EventoCard {...ev} />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Eventos;
